export default __webpack_public_path__ + "static/media/Earnings-Call-Audio-Recording-Q1FY27.6ccbe7be.mp3";